/**
 * SessionStorage gate for `/auth-failure`: the route is reachable by URL, but we only
 * want to show it after our code routes there (AuthenticatedShell / navigationService).
 * Call `allowAuthFailurePageView()` immediately before navigating; `AuthFailurePage`
 * redirects home if the flag is missing. Clear the flag when leaving the screen
 * (try again, logout, or authenticated redirect).
 */
const AUTH_FAILURE_GATE_STORAGE_KEY = 'bennie-auth-failure-just-navigated';
const AUTH_FAILURE_GATE_ALLOWED = '1';

export function allowAuthFailurePageView() {
  sessionStorage.setItem(AUTH_FAILURE_GATE_STORAGE_KEY, AUTH_FAILURE_GATE_ALLOWED);
}

export function clearAuthFailurePageGate() {
  sessionStorage.removeItem(AUTH_FAILURE_GATE_STORAGE_KEY);
}

export function isAuthFailurePageViewAllowed() {
  return sessionStorage.getItem(AUTH_FAILURE_GATE_STORAGE_KEY) === AUTH_FAILURE_GATE_ALLOWED;
}
